<template>
  <div class="relative min-h-[calc(100vh-5rem)] py-10 grid grid-cols-1 lg:grid-cols-2 space-x-10 content-center max-w-screen-xl">
    <div>
      <!-- TODO: style title below when designs are available -->
      <div v-if="props.step?.title" class="hidden">{{ props.step.title }}</div>
      <FormKit type="group" :name="step.code">
        <StepItem
          v-for="(item, index) in questionsAndInfos"
          :key="`${item.item_type}-${index}`"
          :item="item"
          :first="false"
          :set-info-text="setInfoText"
          :item-number="index"
          :active-input-name="`${activeInfoTextItem?.activeToolTipUniqueName}`"
        />
        <slot></slot>
      </FormKit>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import StepItem from '@/questionnaire/components/StepItem.vue'
import type { Step } from '@/questionnaire/types'
import type { InfoItem } from '@/admin/types'

const props = defineProps<{
  step: Step
}>()

const activeInfoTextItem = ref({
  title: '',
  text: '',
  activeToolTip: '',
  activeToolTipUniqueName: '',
})

const setInfoText = ({ label = '', info = '', name = '' }: InfoItem, tooltipIdentifier?: string) => {
  activeInfoTextItem.value = {
    text: info,
    title: label,
    activeToolTip: name,
    activeToolTipUniqueName: `${name}-${tooltipIdentifier}`,
  }
}

const questionsAndInfos = computed(() => {
  return props.step.items.filter(item => item.item_type !== 'hint')
})
</script>

<style>
@media (max-width: 1023px) {
  .ls-info-textbox {
    display: block !important;
  }
}
</style>
